__turbopack_context__.v({
  "captcha-field-box": "sIc2na_captcha-field-box",
});
